<template>
  <div class="damages bg-white has-shadow is-rounded mb-3 result-box">
    <div class="damage-header" @click.prevent="expanded = !expanded">
      <i class="icon-alert"></i>
      <div>
        <h4>{{ $lang.translate('track.label.deviation')}}</h4>
        <p v-if="damages.length == 1">{{ damages[0].event }}</p>
      </div>
      <i class="expander" :class="{'icon-caret-down': !expanded, 'icon-caret-up': expanded}"></i>
    </div>
    <div v-show="expanded">
      <PrintButton />
      <Damage v-for="(damage, index) in damages" :key="index" :damage="damage" @openModal="openModal" />
    </div>
    <Modal :active="modalOpen" @close="modalOpen = false">
      <img v-if="modalImage" :src="modalImage" class="has-shadow" />
    </Modal>
  </div>
</template>

<script>
import Damage from './Damage'
import Modal from '../Modal'
import PrintButton from './PrintButton'

export default {
  name: 'Damages',
  data () {
    return {
      expanded: false,
      modalOpen: false,
      modalImage: null
    }
  },
  props: {
    damages: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  components: {
    Damage,
    Modal,
    PrintButton
  },
  methods: {
    
    openModal(imageUrl) {
      this.modalImage = imageUrl
      this.modalOpen = true
    }
  }
}
</script>
<style scoped>
.damages {
  border: 2px solid #F46113;
  padding: 8px 40px;
}
.damage-header {
  position: relative;
}
.result-box {
  padding-left: 70px;
}

.damage-header i.expander {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}

i.icon-alert {
  color: #F46113;
  font-size: 24px;
  position: absolute;
  top: 3px;
  left: -50px;
}

</style>